import { render, staticRenderFns } from "./legendBox8.vue?vue&type=template&id=039680d0&scoped=true&"
import script from "./legendBox8.vue?vue&type=script&lang=js&"
export * from "./legendBox8.vue?vue&type=script&lang=js&"
import style0 from "./legendBox8.vue?vue&type=style&index=0&id=039680d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039680d0",
  null
  
)

export default component.exports